import React from 'react';
import { useProcessStatusContext } from './context/ProcessStatusContext';
import { ProcessRequestStatus, ProcessState } from '../../../../Services/WorkflowServicesTypes';
import Btn from '../../../../Components/Btn';
import { dateUtils } from '../../../../Util/DateUtil';
import { IconTooltip } from '../../../../Components/Tooltip/IconTooltip';

const { humanizedDurationFromNow } = dateUtils();

const ProcessStatusButton = () => {
	const {
		canView,
		processWorkflowState,
		syncIsDisabled,
		handleStartSynchroRequested,
		handleShowDetailsRequested,
	} = useProcessStatusContext();

	if (!canView) return null;

	if (processWorkflowState?.mainState == null) {
		return null;
	}

	const getStatus = () => {
		switch (processWorkflowState.mainState.processState) {
			case ProcessState.OnGoing:
				return <span className='grey_2 s_13 mr_10'>Sync in progress</span>;
			case ProcessState.Pending:
				return <span className='grey_2 s_13 mr_10'>Sync pending</span>;
			case ProcessState.TerminatedWithError:
				return (
					<span className='grey_2 s_13 mr_10'>
						<IconTooltip
							icon="fas fa-times-circle"
							tooltip={'An occured durring the last sync'}
						/>
						Last sync: {humanizedDurationFromNow(processWorkflowState.mainState.stateDateUtc)}
					</span>
				);
			case ProcessState.TerminatedWithNoOp:
			case ProcessState.TerminatedWithSuccess:
				return <span className='grey_2 s_13 mr_10'>Last sync: {humanizedDurationFromNow(processWorkflowState.mainState.stateDateUtc)}</span>;
			default:
				return null;
		}
	};

	const getButton = () => {
		const getNumberOfPendingRequests = () => processWorkflowState.mainState.requests?.filter(x => x.requestStatus === ProcessRequestStatus.Pending).length ?? 0;

		switch (processWorkflowState.mainState.processState) {
			case ProcessState.OnGoing:
			case ProcessState.Pending:
				return (
					<Btn
						color="secondary"
						style="outline"
						icon="fas fa-sync-alt"
						message={'Sync'}
						size="s"
						isLoading={true}
					/>
				);
			case ProcessState.TerminatedWithError:
			case ProcessState.TerminatedWithNoOp:
			case ProcessState.TerminatedWithSuccess:
			{
				const numberOfPendingRequests = getNumberOfPendingRequests();
				let message = 'Sync';
				if (numberOfPendingRequests > 0) {
					message = numberOfPendingRequests + ' upcoming request';
				}
				return (
					<Btn
						color="secondary"
						style="outline"
						icon="fas fa-sync-alt"
						message={message}
						disabled={syncIsDisabled}
						size="s"
						onClick={() => numberOfPendingRequests > 0 ? handleShowDetailsRequested() : handleStartSynchroRequested()}
					/>
				);
			}
			default:
				return null;
		}
	};


	return (<>
		{getStatus()}
		{getButton()}
	</>);

};


export default ProcessStatusButton;